import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { PortfolioIcon } from '@/components/ui/PortfolioIcon'
import type { ArticleDiagramContent } from '@/components/ui/ArticleDiagram'
import { articleMedia } from '@/content/articleMedia'

export type TechnicalArticle = {
  slug: string
  featured?: boolean
  category: string
  title: string
  summary: string
  reading: string
  intro: string
  image: { alt: string; caption: string }
  diagram: ArticleDiagramContent
  sections: {
    title: string
    paragraphs: string[]
    table?: { caption: string; headers: string[]; rows: string[][] }
    links?: { label: string; href: string }[]
  }[]
}

export function Writing() {
  const { t } = useTranslation()
  const homeUrl = '/'
  const articles = t('portfolio.articles', {
    returnObjects: true,
  }) as TechnicalArticle[]
  const featured = articles.find((article) => article.featured)
  return (
    <section id="writing" className="writing-section section-pad">
      <div className="shell writing-grid">
        <div className="writing-feature">
          <img
            src={
              featured
                ? articleMedia[featured.slug]?.src
                : '/images/portfolio/notebook.webp'
            }
            alt={featured?.image.alt ?? t('portfolio.writing.image')}
            loading="lazy"
            width="271"
            height="128"
          />
          <div>
            <p className="eyebrow">{t('portfolio.writing.eyebrow')}</p>
            <h2>{t('portfolio.writing.title')}</h2>
            {featured ? (
              <>
                <h3>{featured.title}</h3>
                <p>{featured.summary}</p>
                <Link
                  className="featured-article-link"
                  to={`${homeUrl}writing/${featured.slug}`}
                >
                  {t('portfolio.writing.readFeatured')}
                  <PortfolioIcon name="arrow" />
                </Link>
              </>
            ) : (
              <p>{t('portfolio.writing.description')}</p>
            )}
          </div>
        </div>
        <div className="article-list">
          {articles
            .filter((article) => !article.featured)
            .map((article) => (
              <Link
                className="article-preview"
                to={`${homeUrl}writing/${article.slug}`}
                key={article.slug}
              >
                <img
                  className="article-thumbnail"
                  src={articleMedia[article.slug]?.src}
                  alt=""
                  loading="lazy"
                  width="120"
                  height="90"
                />
                <div>
                  <p className="article-category">
                    {article.category}
                    <span>{article.reading}</span>
                  </p>
                  <h3>{article.title}</h3>
                  <p>{article.summary}</p>
                </div>
                <PortfolioIcon name="arrow" />
              </Link>
            ))}
        </div>
      </div>
    </section>
  )
}
